module.exports = __webpack_public_path__ + "img/hero-07-2.ba533d8a.jpg";